import clsx from 'clsx';
import { Avatar, Heading, IconButton } from 'copilot-design-system';
import React, { useContext } from 'react';

import { FlagsContext, PortalConfig } from 'src/context';

interface Props {
  onExit: () => void;
  isActualCheckout: boolean;
  portalConfig: PortalConfig;
}

export const BrandingHeader: React.FC<Props> = ({
  onExit,
  isActualCheckout,
  portalConfig,
}) => {
  const { EnableLegacyAvatarColorMapping } = useContext(FlagsContext);
  const logo = portalConfig.assets.logo.iconImageUrl;
  const portalName = portalConfig.name;

  return (
    <div className="relative" onClick={onExit}>
      <div className="group cursor-pointer flex items-center h-[34px] transition-all">
        <div
          className={clsx(' -left-[24px] top-2.5 transition-all duration-300', {
            'lg:absolute mr-2 lg:mr-0 ': isActualCheckout,
            'mr-2': !isActualCheckout,
          })}
        >
          <IconButton
            className="p-0 text-gray-small group-hover:text-black-heading  cursor-pointer [&>svg]:h-[16px] [&>svg]:w-[16px]"
            label="Back"
            icon="ArrowLeft"
            variant="minimal"
            onClick={onExit}
          />
        </div>

        <div className="flex items-center gap-2 overflow-hidden">
          <Avatar
            size="lg"
            text="Logo"
            variant="circle"
            src={logo}
            className="group-hover:!h-0 group-hover:!w-0 w-8 h-8 transition-all duration-300"
            fallbackColor="transparent"
            useNewColors={EnableLegacyAvatarColorMapping}
          />
          <Heading className="text-black-heading text-[16px] group-hover:hidden">
            {portalName}
          </Heading>
        </div>
        <div className="hidden group-hover:block text-black-heading transition-all duration-300">
          <Heading className=" text-[16px] transition duration-300  ">
            Back
          </Heading>
        </div>
      </div>
    </div>
  );
};
